"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectors = undefined;
exports.init = init;

var _player = require("@vimeo/player");

var _player2 = _interopRequireDefault(_player);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectors = exports.selectors = {
  container: "[data-video-container]",
  playButton: "[data-play-button]",
  video: "[data-video]",
  image: "[data-image]",
  text: "[data-text]"
}; /* Placeholder image with play button to video. Supports both Vimeo and HTML. */

function init() {
  if (document.querySelector(selectors.playButton)) {
    document.querySelectorAll(selectors.playButton).forEach(function (item) {
      item.addEventListener("click", function () {
        item.closest(selectors.container).querySelector(selectors.image).classList.add("hidden");
        if (item.closest(selectors.container).querySelector(selectors.text)) {
          item.closest(selectors.container).querySelector(selectors.text).classList.add("hidden");
        }
        item.classList.add("hidden");
        var video = item.closest(selectors.container).querySelector(selectors.video);
        video.classList.remove("hidden");

        if (video) {
          var video_el = video.querySelector("video");
          if (video_el) {
            video_el.play();
          } else {
            var player = new _player2.default(item.parentElement.querySelector(selectors.video));
            player.getCurrentTime().then(function (seconds) {
              if (seconds > 0) {
                player.setCurrentTime(0).then(function () {
                  player.play();
                });
              } else {
                player.play();
              }
            });
            player.on("ended", function () {
              item.closest(selectors.container).querySelector(selectors.image).classList.remove("hidden");
              if (item.closest(selectors.container).querySelector(selectors.text)) {
                item.closest(selectors.container).querySelector(selectors.text).classList.remove("hidden");
              }
              item.classList.remove("hidden");
              item.closest(selectors.container).querySelector(selectors.video).classList.add("hidden");
            });
          }
        }
      });
    });
  }
}